import LoginPage from './login-page'
import connector from './connector'

export default connector(LoginPage)
